<template>
<div class="chapter">
<div class="inner_page">
<h1 class="CH-T"><strong>Creative Photography Ideas Using<br/>Adobe Photoshop</strong></h1>
<h2 class="CH-SUB"><strong>COMPOSITES AND FURTHER SPECIAL EFFECTS</strong></h2>
<h3 class="CH-AU"><strong>TONY WOROBIEC</strong><br/><br/></h3>
<p class="Image-C"><img alt="" src="OEBPS/images/logo.gif"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?326591ce